import { LearningPathsSubpage } from './LearningPathsSubpage';
import { useLearningPathsData } from './useLearningPathsData';
import { SIDEBAR_ITEMS } from './useSidebarItems';

export const LearningPathsInProgress = () => {
  const { sortedInProgressLps, organizationName, isLoading } =
    useLearningPathsData();

  return (
    <LearningPathsSubpage
      title={SIDEBAR_ITEMS.IN_PROGRESS}
      learningPaths={sortedInProgressLps}
      organizationName={organizationName}
      isLoading={isLoading}
    />
  );
};
